export const INITIAL_STATE = {
  isInitial: true,
  playbackSettings: {},
  isActiveDateInputDialog: false,
  rgPlaybackObjects: {},
  layerFilters: {
    isMyVesselVisibility: true,
    isOtherVesselVisibility: true,
    isPrivatePlotVisibility: false, // addonある時のみtrueに変更可能
    isRgObjectVisibility: true,
  },
  // マップ上で選択状態のオブジェクトのidを保持
  visibleTracks: {
    vessels: [], // string[]
    rgObject: [], // string[]
  },
  privatePlots: [],
  cameras: [],
  radarGridCameraMaster: {},
  expandImgRgObjects: [
    // {id: string, src: string, trackNumber: string, aiseaCameraName: string}
  ], // 拡大表示中のオブジェクトの情報を保持
};

export default {
  ...INITIAL_STATE,
};
